import { inject, Injectable } from '@angular/core';
import { defer, Observable, throwError } from 'rxjs';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { catchError, map } from 'rxjs/operators';

export type GetSignedUrlParams = ({
  fileName?: string,
} | {
  fullPath?: string,
  fallbackFileName?: string,
}) & {
  term?: { value: number, type: 'y' }
};

@Injectable({
  providedIn: 'root',
})
export class GetSignedUrlService {
  private readonly functions = inject(Functions);

  get(params: GetSignedUrlParams): Observable<string> {
    if ('fullPath' in params && params.fullPath) {
      const { fallbackFileName, ...requestParams } = params;
      return this.call(requestParams).pipe(
        catchError((error: unknown) => {
          if (!fallbackFileName) return throwError(() => error);
          return this.call({ fileName: fallbackFileName, term: params.term });
        }),
      );
    }
    return this.call(params);
  }

  private call(params: object): Observable<string> {
    return defer(() =>
      httpsCallable<object, { url: string[] }>(this.functions, 'getCompanySignedUrl')(params)
    ).pipe(
      map(response => {
        const [ url ] = response.data.url;
        if (!url) throw new Error('Error: missed url');
        return url;
      }),
    );
  }
}
